module.exports = __webpack_public_path__ + "img/logo_blue.c7d9baa6.png";